import OnboardingTour from './component';
export default OnboardingTour;

